import LegacyInterceptor from '@finx/web-repository/src/apis/Legacy/LegacyInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { RecebimentoFiltro } from '@/types/_'

const factory = new FactoryResponse()
const api = new LegacyInterceptor()
const totalList: number = 30

export default {
  async loadRecebimentos(params: any) {
    let query: string = ''

    if (params.situacao) {
      query += `&situacao=${params.situacao}`
    }

    if (params.dataFim) {
      query += `&dataFim=${params.dataFim}`
    }

    if (params.dataInicio) {
      query += `&dataInicio=${params.dataInicio}`
    }

    if (params.fontePagadoraIds.length > 0) {
      const fontePagadoraIds = `&fontePagadoraIds=${params.fontePagadoraIds.join('&fontePagadoraIds=')}`
      query += `${fontePagadoraIds}`
    }

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`users/current/recebimentos${query}`)
    return factory.build(request)
  },

  async getFontePagadoraLoggedUser() {
    const request = await api.get('users/current/fonte-pagadora-repasse-disponivel')
    return factory.build(request)
  },

  async recebimentoAcoes() {
    const request = await api.get('users/current/recebimentos/acoes')
    return factory.build(request)
  },

  async getDadosContratoEGestores() {
    const request = await api.get('users/current/contrato-e-gestores')
    return factory.build(request)
  },

  async loadRecebimentoItens(filtro: RecebimentoFiltro) {
    let queryString: string = ''
    queryString = `contratoId=${filtro.contratoId}&pagina=${filtro.pagina}&qtdPorPagina=${totalList}`

    if (filtro.numeroAtendimento) {
      queryString += `&numeroAtendimento=${filtro.numeroAtendimento}`
    }

    if (filtro.paciente) {
      queryString += `&nomePaciente=${filtro.paciente}`
    }

    if (filtro.profissionalExecutante) {
      queryString += `&profissionalExecutante=${filtro.profissionalExecutante}`
    }

    if (filtro.procedimento) {
      queryString += `&codigoProcedimento=${filtro.procedimento}`
    }

    if (filtro.dataRealizacaoInicial) {
      queryString += `&dataRealizacaoInicial=${filtro.dataRealizacaoInicial}`
    }

    if (filtro.dataRealizacaoFinal) {
      queryString += `&dataRealizacaoFinal=${filtro.dataRealizacaoFinal}`
    }

    const request = await api.get(`recebimentos/${filtro.prestadorRecebimentoId}/itens?${queryString}`)
    return factory.build(request)
  },

  async loadProfissionaisExecutantes(prestadorRecebimentoId: string, contratoId: string) {
    const request = await api.get(`recebimentos/${prestadorRecebimentoId}/profissionais-executantes?contratoId=${contratoId}`)
    return factory.build(request)
  },

  async loadPacientes(prestadorRecebimentoId: string, contratoId: string) {
    const request = await api.get(`recebimentos/${prestadorRecebimentoId}/pacientes?contratoId=${contratoId}`)
    return factory.build(request)
  },

  async loadProcedimentos(prestadorRecebimentoId: string, contratoId: string) {
    const request = await api.get(`recebimentos/${prestadorRecebimentoId}/procedimentos?contratoId=${contratoId}`)
    return factory.build(request)
  },

  async exportarExcel(prestadorRecebimentoId: string) {
    const request = await api.getBlob(`recebimentos/${prestadorRecebimentoId}/exportar`)
    return factory.build(request)
  },

  async getValoresCalculados(params: any) {
    const request = await api.get(`recebimentos/${params}/itens/composicao-somatorio`)
    return factory.build(request)
  },

  async getHomeRebimento() {
    const request = await api.get('home/recebimento')
    return factory.build(request)
  },

  async getHomeRebimentoByMesReferencia(mesAnoReferencia) {
    const mesReferencia = mesAnoReferencia || new Date().toISOString().slice(0, 10)
    const request = await api.get(`home/recebimento/${mesReferencia}`)
    return factory.build(request)
  },

  async getRelatorioTemplate() {
    const request = await api.get('users/current/relatorios/template')
    return factory.build(request)
  },

  async getRelatorioProducaoSemRepasse(qnt: number) {
    const request = await api.get(`users/current/relatorios/producao-sem-repasse?QuantidadeMesesParaExibir=${qnt}`)
    return factory.build(request)
  },
}
